import MoreLink from "plos/src/components/links/MoreLink";
import { useTranslation } from "react-i18next";
import { useTrackingContext } from "../../../contexts/TrackingContext";
import EntryInfoPanel from "../EntryInfoPanel";

const AdminPanel = () => {
  const { t } = useTranslation();
  const { fireClickTrackEvent } = useTrackingContext();

  const userProfileUrl = `${
    import.meta.env.VITE_HF_BASE
  }/en/settings/personal-details`;

  const trackAdminClick = (
    eventDetail: "View Team Details" | "View User Profile",
  ) => {
    fireClickTrackEvent({
      event_component: "button click",
      event_category: "fantasy admin",
      event_detail: eventDetail,
    });
  };

  return (
    <EntryInfoPanel title={t("adminPanel.title", "Admin")}>
      <MoreLink
        to={`/entry-update`}
        onClick={() => trackAdminClick("View Team Details")}
      >
        {t("teamDetails", "Team Details")}
      </MoreLink>

      <MoreLink
        href={userProfileUrl}
        onPress={() => trackAdminClick("View User Profile")}
      >
        {t("userProfile", "User Profile")}
      </MoreLink>
    </EntryInfoPanel>
  );
};

export default AdminPanel;
